import classNames from 'classnames';
import { forwardRef } from 'react';

import PauseIcon from '../icons/PauseIcon';
import PlayIcon from '../icons/PlayIcon';
import BasicButton, { BasicButtonElement, BasicButtonProps } from './BasicButton';

import styles from '../../styles/buttons/control-button.module.css';

export interface PlayButtonProps extends BasicButtonProps {
    playing?: boolean;
    iconClassName?: string;
}

function PlayButtonBase({
    playing = false,
    className = null,
    iconClassName,
    buttonRef,
    ...props
}: PlayButtonProps) {
    return (
        <BasicButton
            ref={buttonRef}
            className={classNames([
                styles.container,
                {
                    [className || '']: !!className,
                },
            ])}
            {...props}
        >
            {playing ? (
                <PauseIcon className={classNames([styles.icon, iconClassName])} />
            ) : (
                <PlayIcon className={classNames([styles.icon, iconClassName])} />
            )}
        </BasicButton>
    );
}

export default forwardRef<BasicButtonElement, Omit<PlayButtonProps, 'buttonRef'>>(
    function PlayButton(props, ref) {
        return <PlayButtonBase {...props} buttonRef={ref} />;
    },
);
